import { t } from "i18next";

const StudentMistakes = ({ LastSession, getMistake }) => {
  const mistakes = LastSession?.reading?.behaviors;

  let mistakesCount = mistakes?.reduce((acc, mistake) => {
    const mistakeId = mistake.behavior;
    acc[mistakeId] = (acc[mistakeId] || 0) + 1;
    return acc;
  }, {});

  if (!mistakesCount) mistakesCount = {};

  const topMistakes = Object.entries(mistakesCount)
    .map(([id, count]) => ({ id, count }))
    .sort((a, b) => b.count - a.count)
    .slice(0, 3)
    .map(({ id }) => id);

  return (
    <div className="student-mistakes-container">
      <h5 className="mistakes-title">{t("profile.focus")}</h5>
      <div className="mistakes-divider" />
      <div className="d-flex flex-wrap gap-2 justify-content-start align-items-center mt-3">
        {topMistakes?.length ? (
          topMistakes.map((mistake, index) => {
            const { color, title } = getMistake(mistake);
            return (
              <div
                key={index}
                className="mistake-badge-pill"
                style={{ backgroundColor: color }}
              >
                <span className="badge-text">{title}</span>
              </div>
            );
          })
        ) : (
          <div className="no-mistakes-text">لا يوجد اخطاء</div>
        )}
      </div>
    </div>
  );
};

export default StudentMistakes;
